/**
 * Parse HTML as document fragment (not as HTML document)
 *
 * @example
 *   const button = parseHTMLFragment('<button type="button">Button</button>').firstElementChild;
 *
 * @example
 *   const svg = parseHTMLFragment(
 *     '<svg xmlns="http://www.w3.org/2000/svg" width="400" height="400"><circle cx="100" cy="100" r="50" stroke="black" stroke-width="5" fill="red" /></svg>'
 *   ).firstElementChild;
 *
 * @example
 *   const { childElementCount } = parseHTMLFragment('<i>i</i> <b>b</b> <em>em</em> <strong>strong</strong>');
 *
 * @example
 *   parseHTMLFragment('<tr><td></td></tr>').firstElementChild.matches('tr');
 *
 * @example
 *   document.body.append(parseHTMLFragment('<script>alert("hello")</script>').firstElementChild); // will open a alert with "hello"
 *
 * @example
 *   document.body.appendChild(parseHTMLFragment('<p>Paragraph 1</p> <p>Paragraph 2</p><p>Paragraph 3</p>'));
 *
 * @param {string} source HTML source
 * @param {Document} [document]
 * @returns {DocumentFragment}
 * @see https://developer.mozilla.org/en-US/docs/Web/API/Element/insertAdjacentHTML
 */
export default (source, document = globalThis.document) =>
  // Parse a template with createContextualFragment. This allows scripts to be activable and table elements to be parsed correctly
  document.createRange().createContextualFragment(`<template>${source}</template>`).firstElementChild.content;
